// extracted by mini-css-extract-plugin
export var actionButton = "_f1-t";
export var buttonContainer = "_f1-0";
export var buttonContainer2 = "_f1-1";
export var buttonSection = "_f1-2";
export var details = "_f1-3";
export var dropdownItem = "_f1-5";
export var dropdownItemsContainer = "_f1-4";
export var fileInput = "_f1-r";
export var headerButton = "_f1-6";
export var icon = "_f1-7";
export var input = "_f1-8";
export var macroListItem = "_f1-9";
export var mainContent = "_f1-a";
export var microText = "_f1-b";
export var modal = "_f1-w";
export var optionsButton = "_f1-c";
export var paperclip = "_f1-s";
export var pillContent = "_f1-d";
export var preview = "_f1-e";
export var preview2 = "_f1-f";
export var quillEditor = "_f1-q";
export var selectedMacro = "_f1-g";
export var sidebar = "_f1-h";
export var sidebarHeader = "_f1-j";
export var sidebarList = "_f1-i";
export var sidebarListItem = "_f1-k";
export var sidebarSearch = "_f1-l";
export var snoozeDurationWrapper = "_f1-v";
export var statusPillContainer = "_f1-m";
export var tagsContainer = "_f1-n";
export var unselectedMacro = "_f1-o";
export var variable = "_f1-u";
export var wrapper = "_f1-p";